'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _utilsLink = require('@bibliocommons/utils-link');

var _availabilityStatus = require('@bibliocommons/availability-status');

var _availabilityStatus2 = _interopRequireDefault(_availabilityStatus);

var _holdCounts = require('@bibliocommons/hold-counts');

var _holdCounts2 = _interopRequireDefault(_holdCounts);

var _analyticsEventComposers = require('@bibliocommons/analytics-event-composers');

var _baseScreenReaderMessage = require('@bibliocommons/base-screen-reader-message');

var _baseScreenReaderMessage2 = _interopRequireDefault(_baseScreenReaderMessage);

var _Pill = require('./Pill.component');

var _Pill2 = _interopRequireDefault(_Pill);

var _FormatIcon = require('./FormatIcon');

var _FormatIcon2 = _interopRequireDefault(_FormatIcon);

var _AvailabilityIcon = require('./AvailabilityIcon');

var _AvailabilityIcon2 = _interopRequireDefault(_AvailabilityIcon);

require('../styles/FormatPickerToken.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var composeFormatPickerSelectionEvent = _analyticsEventComposers.bibFormatChooser.composeFormatPickerSelectionEvent;


var FormatPickerToken = function FormatPickerToken(_ref) {
  var _ref$metadataId = _ref.metadataId,
      metadataId = _ref$metadataId === undefined ? '' : _ref$metadataId,
      item = _ref.item,
      _ref$active = _ref.active,
      active = _ref$active === undefined ? false : _ref$active,
      _ref$editionCount = _ref.editionCount,
      editionCount = _ref$editionCount === undefined ? 3 : _ref$editionCount,
      handleGTMEvent = _ref.handleGTMEvent;

  var clickHandler = function clickHandler() {
    handleGTMEvent(composeFormatPickerSelectionEvent(item.getIn(['briefInfo', 'format'])));
  };

  return _react2.default.createElement(
    'div',
    { className: 'cp-format-picker' },
    _react2.default.createElement(
      _Pill2.default,
      { url: '/item/show/' + (0, _utilsLink.metadataIdFixer)(metadataId), handleClick: clickHandler, className: item.getIn(['availability', 'status']).toLowerCase(), active: active },
      _react2.default.createElement(_FormatIcon2.default, { format: item.getIn(['briefInfo', 'format']), width: 16, height: 16 }),
      _react2.default.createElement(
        _reactIntl.FormattedMessage,
        { id: 'FORMAT.' + item.getIn(['briefInfo', 'format']).toLowerCase() },
        function (message) {
          return _react2.default.createElement(
            'div',
            { className: 'format-publication-date', 'aria-hidden': true },
            message,
            item.getIn(['briefInfo', 'publicationDate']) && ' - ' + item.getIn(['briefInfo', 'publicationDate'])
          );
        }
      ),
      _react2.default.createElement(
        _baseScreenReaderMessage2.default,
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactIntl.FormattedMessage,
            { id: 'FORMAT.' + item.getIn(['briefInfo', 'format']).toLowerCase() },
            function (message) {
              return _react2.default.createElement(
                'div',
                { className: 'format-publication-date' },
                message,
                item.getIn(['briefInfo', 'publicationDate']) && ' - ' + item.getIn(['briefInfo', 'publicationDate'])
              );
            }
          ),
          _react2.default.createElement(_AvailabilityIcon2.default, { status: item.getIn(['availability', 'status']), width: 12, height: 12 }),
          _react2.default.createElement(_availabilityStatus2.default, {
            rollUpStatus: item.getIn(['availability', 'status']),
            status: item.getIn(['availability', 'localisedStatus']),
            availabilityLocationType: item.getIn(['availability', 'availabilityLocationType']) }),
          _react2.default.createElement(_holdCounts2.default, {
            tagElement: 'div',
            localeKey: 'holdCountAlt',
            heldCopies: item.getIn(['availability', 'heldCopies']),
            availableCopies: item.getIn(['availability', 'availableCopies']),
            totalCopies: item.getIn(['availability', 'totalCopies']) }),
          _react2.default.createElement(
            _reactIntl.FormattedMessage,
            { id: active ? 'additional_edition_count' : 'edition_count', values: { count: editionCount } },
            function (message) {
              return editionCount >= 1 ? _react2.default.createElement(
                'div',
                { className: 'group-size' },
                message
              ) : null;
            }
          )
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'additional-info' },
      _react2.default.createElement(_AvailabilityIcon2.default, { status: item.getIn(['availability', 'status']), width: 12, height: 12 }),
      _react2.default.createElement(_availabilityStatus2.default, {
        'aria-hidden': true,
        rollUpStatus: item.getIn(['availability', 'status']),
        status: item.getIn(['availability', 'localisedStatus']),
        availabilityLocationType: item.getIn(['availability', 'availabilityLocationType']) }),
      _react2.default.createElement(_holdCounts2.default, {
        'aria-hidden': true,
        tagElement: 'div',
        localeKey: 'holdCountAlt',
        heldCopies: item.getIn(['availability', 'heldCopies']),
        availableCopies: item.getIn(['availability', 'availableCopies']),
        totalCopies: item.getIn(['availability', 'totalCopies']) }),
      _react2.default.createElement(
        _reactIntl.FormattedMessage,
        { id: active ? 'additional_edition_count' : 'edition_count', values: { count: editionCount } },
        function (message) {
          return editionCount >= 1 ? _react2.default.createElement(
            'div',
            { 'aria-hidden': true, className: 'group-size' },
            message
          ) : null;
        }
      )
    )
  );
};

FormatPickerToken.propTypes = {
  handleGTMEvent: _react.PropTypes.func.isRequired,
  active: _react.PropTypes.bool.isRequired,
  metadataId: _react.PropTypes.string,
  item: _react.PropTypes.objectOf(_react.PropTypes.any).isRequired,
  editionCount: _react.PropTypes.number.isRequired
};

exports.default = FormatPickerToken;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/format-picker-token/lib/components/FormatPickerToken.component.js
// module id = 1179
// module chunks = 9